import React, { useMemo } from 'react';

import { PercentageDiff } from 'components/Statistic/PercentageDiff';

type HottestCompanyJobsProps = {
  jobs: any[],
  loading: boolean,
  targetChangedCount?: number,
};

export function HottestCompanyJobs({ jobs = [], loading, targetChangedCount = 0 }: HottestCompanyJobsProps) {
  const items = useMemo(() => {
    return jobs.map((job) => ({
      title: `${job.companyJobTitle} ${job.paymarketName}`, diff: Math.round(job.hotRate*100),
    }));
  }, [jobs]);

  const footnote = targetChangedCount > 0
    ? `${targetChangedCount} ${targetChangedCount === 1 ? 'job is' : 'jobs are'} not compared: the target pay element or percentile changed from the previous plan.`
    : undefined;

  return (
    <PercentageDiff items={items} loading={loading} footnote={footnote} />
  );
}
